import React from "react";
import Carousel from "./Carousel.tsx";

const HashtagCarousel = () => {
  const hashtags = [
    ["Hearty", "Earth"],
    ["Aspire", "2", "Inspire"],
    ["Inspire", "Inclusion"],
    ["Share", "The", "Love"],
    ["Be", "The", "Change"],
    ["Think", "Global", "Act", "Local"],
  ];

  return (
    <Carousel
      carouselItems={hashtags.map((arr, index) => {
        return (
          <div key={`big-hashtag-${index}`} className="d-flex flex-wrap">
            <h1 className="hashtag">#</h1>
            {arr.map((str, strIndex) => {
              return (
                <h1 key={`big-hastag-${index}-${strIndex}`} className="hashtag">
                  {str}
                </h1>
              );
            })}
          </div>
        );
      })}
      axis="vertical"
      height={100}
      centerSlidePercentage={50}
      autoPlay={true}
      interval={6000}
      infiniteLoop={true}
      showThumbs={false}
      showArrows={false}
      showIndicators={false}
      showStatus={false}
      stopOnHover={true}
      swipeable={false}
      useKeyboardArrows={false}
      centerMode={true}
      onClickItem={(index, item) => {
        console.log(index, item);
      }}
    />
  );
};

export default HashtagCarousel;
